import React from 'react';
import { useController } from 'react-hook-form';

export const InputField = ({ label, name, defaultValue, value, onChange, onBlur, register, explanation, rules, error, disabled, maxLength }) => {
    const reg = register ? {...register(name, rules)} : {
        onChange,
        name,
        value
    };
    return (
        <div className='mb-3 flex w-full'>
            <label className='w-1/6 text-uidarker font-medium pr-6 text-right'>{label}:{rules && <span className='text-red'>*</span>}</label>
            <div className='flex flex-col w-full max-w-xs'>
            <input
                type="text"
                {...reg}
                onBlur={onBlur}
                defaultValue={defaultValue}
                maxLength={maxLength}
                disabled={disabled}
                className={`border-solid border-2 border-uidark rounded-full py-1 px-4 focus:bg-white ${error ? 'border border-red focus:outline-red' : ''} ${disabled ? 'bg-ui cursor-not-allowed' : 'bg-uilight'}`}
            />
            {explanation && (
                <span className='text-brandDarkBlue text-xs text-gray-500 my-1'>{explanation}</span>
            )}
            {error && <span className='text-red text-xs'>{error}</span>}
            </div>
        </div>
    )
};

export const HookFormInputField = (props) => {
    const { field } = useController(props);
    return (
        <div className='mb-3 flex items-center w-full'>
            <label className='w-1/6 text-uidarker font-medium pr-6 text-right'>{props.label}:</label>
            <input
                {...field}
                type="text"
                placeholder={props.placeholder}
                onBlur={props.onBlur}
                className='bg-uilight border-solid border-2 border-uidark rounded-full py-1 px-4 w-full max-w-xs focus:bg-white'
            />
        </div>
    )
}

export default InputField;
